"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeRecipeFromSectionMutationOptions = exports.removeRecipeFromSectionMutation = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const updateQuery_1 = require("../../../utils/updateQuery");
const recipesByCookbookAndSectionId_1 = require("../queries/recipesByCookbookAndSectionId");
exports.removeRecipeFromSectionMutation = graphql_tag_1.default `
  mutation RemoveRecipeFromSection($options: RemoveRecipeFromSectionOptions!) {
    removeRecipeFromSection(options: $options) {
      ok
    }
  }
`;
exports.removeRecipeFromSectionMutationOptions = (variables) => ({
    variables,
    update: cache => {
        updateQuery_1.updateQuery(cache, recipesByCookbookAndSectionId_1.recipesByCookbookAndSectionIdQuery, x => {
            x.recipesByCookbookAndSectionId = x.recipesByCookbookAndSectionId.filter(y => y.id !== variables.options.recipeId);
        }, {
            sectionId: variables.options.sectionIdToRemove,
        });
        updateQuery_1.updateFragment(cache, `Recipe:${variables.options.recipeId}`, `
            cookbookSectionLookup {
              cookbook {
                id
                name
                accessLevel
              }
              section {
                id
                name
              }
            }
    `, x => {
            if (x.cookbookSectionLookup) {
                x.cookbookSectionLookup = x.cookbookSectionLookup.filter(y => y.section.id !== variables.options.sectionIdToRemove);
            }
        });
    },
});
//# sourceMappingURL=removeRecipeFromSection.js.map